import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import SectionTopics from '@/pages/home/components/SectionTopics';
import SectionCards from '@/pages/home/components/SectionCards';
import SectionIndex from '@/pages/home/components/SectionIndex';
import SectionRanking from '@/pages/home/components/SectionRanking';
import SectionFeatures from '@/pages/home/components/SectionFeatures';
import SectionApp from '@/pages/home/components/SectionApp';
import SectionCarousel from '@/pages/home/components/SectionCarousel';
import SectionComments from '@/pages/home/components/SectionComments';
import SectionContact from '@/pages/home/components/SectionContact';
import SectionFAQ from '@/pages/home/components/SectionFAQ';
import SectionAbout from '@/pages/home/components/SectionAbout';
import SectionMedia from '@/pages/home/components/SectionMedia';
import SectionUpdates from '@/pages/home/components/SectionUpdates';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-sans">
      <Header />
      <main>
        <Hero />
        <SectionTopics />
        <SectionCards />
        <SectionIndex />
        <SectionRanking />
        <SectionFeatures />
        <SectionApp />
        <SectionCarousel />
        <SectionComments />
        <SectionContact />
        <SectionFAQ />
        <SectionAbout />
        <SectionMedia />
        <SectionUpdates />
      </main>
      <Footer />
    </div>
  );
}